<template>
  <div class="home_wrap">
    <van-nav-bar :title="$t('最近的')" left-text="" left-arrow @click-left="onClickLeft" />
    <!-- 搜索 -->
    <div v-show="true" class="search-wrap">
      <input v-model="keyword" class="input-keyword" type="text" :placeholder="$t('搜索')">
      <van-icon name="search" class="simg" />
    </div>
    <div class="game-bg">
      <div id="game-left-bg" style="width: 25%">
        <!-- <div v-if="show">
          <div class="game-left-item" :class="left_active == 0 ? 'nav_ac' : ''" @click="changeLeftNav(0)">
            <div style="margin-top: .1rem;">
              <img v-if="!title" class="icon" src="../../assets/images/recent/Recente.png" alt="">
              <img v-else class="icon" src="../../assets/images/recent/Favoritos.png" alt="">
            </div>
            <span class="ppl">{{ title || $t('最近的') }}</span>
          </div>
        </div> -->
        <div>
          <div v-for="(item, index) in tabs" :key="item.id" class="game-left-item"
            :class="left_active == index ? 'nav_ac' : ''" @click="changeLeftNav(index)">
            <img class="nav_img" :src="item.image">
            <span class="ppl">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div id="game-right-bg">
        <div class="tab_nav">
          <van-tabs v-model="nav_active" class="van-tabs__wrap--scrollable" :sticky="false" :swipeable="true"
            :swipe-threshold="2" :background="'transparent'" :line-width="0" @change="tabChange">
            <div v-if="show">
              <!-- <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("全部") }}</span>
                  </div>
                </template>
</van-tab> -->
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("热门") }}</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("最近的") }}</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("收藏夹") }}</span>
                  </div>
                </template>
              </van-tab>
            </div>
            <div v-else>
              <van-tab v-if="left_active !== 0">
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("全部") }}</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("热门") }}</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("最近的") }}</span>
                  </div>
                </template>
              </van-tab>
              <van-tab>
                <template #title>
                  <div class="nav_title">
                    <span class="ppl">{{ $t("收藏夹") }}</span>
                  </div>
                </template>
              </van-tab>
            </div>
          </van-tabs>
        </div>
        <div v-if="all_game_list.length == 0" class="nonew-list">
          <img src="../../assets/images/category/noList.png" alt="">
          <p>{{ $t("没有可用的游戏") }}</p>
        </div>
        <div v-else class="new-list">
          <div class="new_box">
            <div class="game-list" :style="{ height: screenHeight + 'px' }">
              <div v-for="(item, index) in all_game_list"
                v-show="(currentPage - 1) * 30 <= index && currentPage * 30 > index" :key="item.id" class="subgame-item"
                @click="playGame(item, result)">
                <img v-if="item.is_collect == 1" class="like_icon" src="../../assets/images/category/like_color.png"
                  alt="" @click.stop="setFavoritos(item)">
                <img v-else class="like_icon" src="../../assets/images/category/like.png" alt=""
                  @click.stop="setFavoritos(item)">
                <div v-lazy:background-image="item.image" class="innerbox" :class="index + '_innerbox'">
                  <div v-if="!item.is_works" class="maintenance-overlay">
                    <img src="../../assets/images/common/nowork.png" class="nowork">
                  </div>
                  <div class="subgame_item_pg_name">
                    {{ item.game_name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页栏 -->
        <div v-if="gameLength > 30" class="geme_page" style="
              position: fixed;
              bottom: 2%;
              left: 37%;
              right: 0;
              display: flex;
              z-index: 100;
            ">
          <van-pagination v-model="currentPage" :items-per-page="30" :total-items="gameLength" @change="PageChange">
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
          </van-pagination>
        </div>
      </div>
    </div>
    <div v-show="show_game_box" id="bigBox" class="game-box">
      <div class="back_to_desk" @click="beforeCloseGame()">
        <van-icon name="wap-home-o" class="close_game_btn" />
        <div style="font-size: 0.3rem">
          {{ $t("退出") }}
        </div>
      </div>
    </div>
    <LogoLoading v-if="showLogoLoading" />
  </div>
</template>

<script>
import Vue from "vue";
import { NavBar, Lazyload, Pagination, Tabs, Tab } from "vant";
import Fetch from "../../utils/fetch";
import LogoLoading from '@/components/logoLoading.vue'
Vue.use(NavBar).use(Pagination).use(Tabs).use(Tab).use(Lazyload, {
  lazyComponent: true,
});

export default {
  name: "SubGame",
  components: {
    LogoLoading
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      keyword: "",
      gamestile: "Slots",
      all_game_list: [],
      all_game_list_bak: [],
      page_game_list: [],
      nav_active: 0,
      perPage: 30,
      step_show: 28,
      max_show_array: [6, 6, 6, 6],
      currentPage: 1,
      category: "type",
      show_game_box: false,
      is_ban: 0,
      username: null,
      i: 0,
      pagecount: 30,
      left_active: 0,
      result: {},
      timer: false,
      screenHeight: "",
      flag: 0,
      show: true,
      oldList: [],
      colletList: [],
      title: '',
      tabs: [],
      showLogoLoading: false
    };
  },
  computed: {
    gameLength() {
      return this.all_game_list ? Object.values(this.all_game_list).length : 0
    },
    colletIds() {
      return this.colletList.map(({ id }) => id)
    }
  },
  watch: {
    pagecount: function () {
    },
    tabs: {
      deep: true,
      handler(n) {
        let flag = this.$route.query.flag;
        if (this.$route.query.cate_id && flag) {
          let type = this.$route.query.cate_id;
          let active = "";
          n.forEach((item, index) => {
            if (type == item.id) {
              active = index;
            }
          })
          this.left_active = active;
        }
      }
    },
    left_active() {
      this.currentPage = 1
    },
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenHeight);
          that.timer = false;
        }, 400);
      }
    },
    keyword: function (newn) {
      if (newn == "") {
        this.all_game_list = this.all_game_list_bak;
        return;
      }
      let allGames = [];
      this.all_game_list_bak.forEach((item) => {
        if (item.game_name.toLowerCase().search(newn.toLowerCase()) != -1) {
          allGames.push(item);
        }
      });
      this.all_game_list = allGames;
    },
  },
  created() {
    this.getUserInfo();
    this.getNav();
    this.title = this.$route.query.title
    console.log(this.$route.query.isHermes)
    if (!this.$route.query.isHermes) {
      this.show = false;
      this.getGanmeTypeList(this.$route.query.cate_id);
    } else {
      if (this.$route.query.index != 0) {
        this.show = true;
        if (this.$route.query.index == 1) {
          this.getCollectList(0);
          this.nav_active = Number(this.$route.query.index)
        } else {
          this.getCollectList(1);
          this.nav_active = Number(this.$route.query.index)
        }
      } else {
        this.show = false;
        this.getGanmeTypeList(this.$route.query.cate_id);
      }
    }
  },
  mounted() {
    window.screenHeight = document.body.clientHeight - 138;
    this.screenHeight = window.screenHeight;
    var that = this;
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight - 138;
        that.screenHeight = window.screenHeight;
      })();
    };
  },
  methods: {
    getGanmeTypeList(id) {
      Fetch("/game/filter", {
        cate_id: id,
      }, { method: "get" }).then((res) => {
        this.result = res.data;
        this.all_game_list = res.data.list.games;
        this.all_game_list_bak = res.data.list.games;
        this.oldList = JSON.parse(JSON.stringify(this.result));
      });
    },
    getNav() {
      Fetch("/platform/nav", {
        is_nav: 0
      }).then((res) => {
        if (res.data) {
          this.tabs = res.data.cate_list
        }
      })
    },
    beforeCloseGame() {
      document
        .getElementById("bigBox")
        .removeChild(document.getElementById("myiframe"));
      this.show_game_box = false;
      this.game_url = "";
      //重新获取用户的余额
      this.getUserInfo();
    },
    showMore() {
      this.step_show += 28;
    },
    PageChange(e) {
      console.log(e, 'e---');
    },
    getGameList() {
    },
    changeLeftNav(idx) {
      this.left_active = idx;
      if (this.nav_active != 0) {
        this.nav_active = 0;
      }
      this.getGanmeTypeList(this.tabs[idx].id);
    },
    getListData(name, list) {
      return {
        slots: {
          name: list || this.oldList[name]
        }
      }
    },
    tabChange(v) {
      this.nav_active = v;
      if (this.show) {
        if (v == 0) {
          // this.flag = 0;
          this.getGanmeTypeList(this.tabs[this.left_active].id);
        } else if (v == 2) {
          this.all_game_list = this.getListData('', this.colletList)
          this.getCollectList(1);
        } else {
          // this.flag = 1;
          this.getCollectList(0);
        }
      } else {
        if (v !== 0) {
          if (this.left_active == 0) {
            if (this.nav_active == 2) {
              this.getCollectList(1)
              return
            } else if (this.nav_active == 1) {
              this.getCollectList(0)
            }
          } else {
            this.left_active = 0;
            if (this.nav_active == 1) {
              this.nav_active = 0;
              this.left_active = 0;
              this.getGanmeTypeList(this.tabs[this.left_active].id);
            } else if (this.nav_active == 2) {
              this.nav_active = 1;
              this.left_active = 0;
              this.getCollectList(0);
            } else if (this.nav_active == 3) {
              this.nav_active = 2
              this.left_active = 0;
              this.getCollectList(1);
            }
          }
        } else {
          this.getGanmeTypeList(this.tabs[this.left_active].id);
        }
      }

    },
    getUserInfo() {
      Fetch("/user/userinfo").then((r) => {
        if (r.data.userinfo) {
          this.userInfo = r.data.userinfo;
          this.username = r.data.userinfo.username;
          this.userbalance = r.data.userinfo.money;
          this.is_ban = r.data.userinfo.is_rob;
        }
      });
    },
    getCollectList(id) {
      Fetch("/game/collectList", {
        type: id
      }, { method: 'get' }).then(res => {
        this.result = res.data.list;
        this.all_game_list = res.data.list;
        this.all_game_list_bak = res.data.list;
        this.oldList = JSON.parse(JSON.stringify(this.result));
      })
    },
    async playGame(item, pItem) {
      // console.log(pItem,'232323')
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          if (pItem.list.name != "PG") {
            return this.$message({
              message: this.$t("模拟账号只能玩PG游戏"),
              type: "error",
            });
          }
        }
      }
      if (!this.username) {
        this.$parent.login();
        return;
      } else {
        //被后台禁止游戏了
        if (this.is_ban) {
          this.$toast({
            background: "#07c160",
            message: this.$t("您当前账号尚未开通游戏功能，请联系您的经理"),
            duration: 5000,
          });
          return;
        }
        if (item.is_works == 0) {
          this.$toast({
            background: "#07c160",
            message: this.$t("该游戏正在维护中"),
            duration: 5000,
          });
          return;
        }
        if (this.userbalance < 0.4) {
          return this.$parent.isShowRecharge = true;
        }
      }
      this.showLogoLoading = true
      // const loading = this.$loading({
      //   lock: true,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
      // setTimeout(() => {
      //   loading.close();
      // }, 2000);
      //存入本地最近游戏游戏列表中
      if (item.is_recent === 0) {
        this.$set(item, 'is_recent', 1)
        await this.getRecent(item.id);
      }
      //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
      //先获取一下游戏的链接
      let resp = await this.getGameUrl(item.id);
      if (resp.code == 0) {
        this.showLogoLoading = false
        this.$toast({
          background: "#07c160",
          message: resp.msg,
          duration: 3000,
        });
        return;
      }
      return this.launchJDB(resp.data.game_url);

    },
    launchJDB(url) {
      this.showLogoLoading = false
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("webkitallowfullscreen", "true");
      iframe.setAttribute("mozallowfullscreen", "true");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },

    createIframe(content) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
      iframe.contentWindow.document.write(
        "<script>alert(1); window.location.href = " + content + ""
      );
    },
    getPGHtml(game_id) {
      return new Promise((resolve) => {
        Fetch(
          "/demo/getPGHtml2",
          { game_id: game_id, token: localStorage.getItem("token") },
          {},
          true
        ).then((res) => {
          resolve(res);
        });
      });
    },
    getGameUrl(gameId) {
      return new Promise((resolve, reject) => {
        Fetch("/game/startup", { game_id: gameId }, { method: 'get' }, false, false).then(
          (res) => {
            resolve(res);
          }
        ).catch(err => {
          reject(err);
        });
      });
    },
    onClickLeft() {
      this.$router.push("/");
    },
    getRecent(id) {
      Fetch("/game/collect", {
        game_id: id,
        type: 0
      }).then(() => {
      })
    },
    setFavoritos(item) {
      Fetch("/game/collect", {
        game_id: item.id,
        type: 1
      }).then(res => {
        if (res.code == 1) {
          if (item.is_collect == 1) {
            item.is_collect = 0;
          } else {
            item.is_collect = 1;
          }
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

// .tab_nav {
//   background-color: @secondary-color;
//   background-size: cover;
// }

/deep/ .van-tabs__wrap--scrollable {
  /* 自定义样式 */
  color: @anttextcolor;
  background: transparent;
  border-width: 1.5rem;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  color: @textcolorf;
}

/deep/ .van-tabs__wrap--scrollable .van-tab--active {

  background-color: @ButtonColor;
}

.van-tab--active .ppl {
  color: @primary-color !important;
}

/deep/ .van-tab {
  min-width: 60px;
  height: 26px;
  border-radius: .2rem;
  // border-bottom: 0.01 solid @bodercolor;
  margin-right: .2rem;
  background: @secondary-color;
  border: 0.01rem solid @bodercolor;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  height: auto;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0 !important;
}

/deep/ .van-tabs__line {
  bottom: 0 !important;
}

.tab_nav {
  padding-right: 15px;
  margin-top: 10px;
}

.ppl {
  font-size: .3rem;
}

.game-bg {
  display: flex;
  // align-items: center;
}

#game-right-bg {
  width: 75%;
}

.home_wrap {
  height: 100%;
  background-color: @activityColor;
}

.nav_title {
  // display: flex;
  // align-items: center;
}

.search-wrap {
  //background: rgba(250, 223, 0,0.8);
  border: 1px solid @bodercolor2;
  height: 26px;
  width: 95%;
  margin: 0.3rem auto 0.1rem auto;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2px;
  box-sizing: border-box;
}

.simg {
  font-size: 0.4rem;
  margin-right: 0.2rem;
  color: @textcolor1;
}

.nonew-list {
  width: 100%;
  text-align: center;
  margin-top: 4rem;

  img {
    width: 105px;
    height: 105px;
  }

  p {
    font-size: .3rem;
    color: @textcolor1;
  }
}

.nav_ac {
  span {
    color: @primary-color !important;
  }
}

.input-keyword {
  width: 70%;
  height: 100%;
  color: #fff;
  font-size: 11px;
  float: left;
  text-indent: 10px;
  background: none;
  border: none;

  input {
    background: none;
    border: none;
    outline: none;
  }
}

.input-keyword::placeholder {
  color: @textcolor2
}

.show_more {
  color: @anttextcolor;
  width: 95%;
  margin: 0 auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;

  div {
    height: 0.5rem;
    line-height: 0.5rem;
    color: @textcolor3;
  }
}

.game-left-item {
  width: 80%;
  color: #c7c7c7;
  background: @secondary-color;
  border-radius: 0.2rem;
  // border-radius: 48%;
  margin: 0.2rem 0 0.4rem 0.2rem;
  padding: 4px 0;
  text-align: center;
  height: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .icon_box {
    width: 25px;
    height: 25px;
    z-index: 2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    width: 30px;
    height: 22px;
  }
}

.path_ac {
  fill: @activityColor !important;
}

.nav_ac {
  color: @primary-color;
  background-color: @ButtonColor;

  svg {
    fill: @primary-color;
  }
}

.nav_img {
  display: block;
  width: 0.8rem;
  // height: .8rem;
  margin: 0 auto;
}

::-webkit-scrollbar {
  display: none;
}

.game-list {
  width: 95%;
  // overflow-y: scroll;
  margin: 0 auto 0rem auto;
  display: flex;
  flex-wrap: wrap;
  align-content: baseline;
  justify-content: space-start;
}

.subgame-item {
  width: 31%;
  // height: 3.6rem;
  margin-right: .16rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;

  // margin-top: .3rem;
  .like_icon {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 9;
  }
}

.new-list {
  position: relative;
  padding: 10px 0;
  height: 86%;
  box-sizing: border-box;

  .new_box {
    height: 100%;
    overflow-y: auto;
  }
}

.maintenance-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: .25rem;
}

.nowork {
  width: 60%;
  height: 60%;
  object-fit: contain;
  filter: brightness(1.2);
}

.game-left-item {
  svg {
    path {
      fill: @ButtonColor;
    }
  }

  &.nav_ac {
    svg {
      path {
        fill: @svgColor;
      }
    }
  }
}

.innerbox {
  width: 100%;
  height: 3.3rem;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, .2);
  border-radius: .25rem;
  box-sizing: border-box;
  margin: 0 auto;
}

.subgame_item_pg_name {
  color: #fff;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin: 0 auto;
  width: 100%;
  font-size: 10px;
  // font-weight: 500;
  left: 0;
  bottom: -5px;
  height: 1rem;
  // line-height: 0.5rem;
}

.game_name {
  width: 100%;
  text-align: center;
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
  bottom: 0.3rem;
  color: #fff;
  font-size: 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  //background-color: rgba(0, 0, 0,0.5);
}

.gameimg-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.game-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.2rem;
}

.game-name {
  font-size: 0.3rem;
  color: #c7c7c7;
  text-align: center;
}

.c-sm-des {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  border-radius: 4px;
  height: 0.8rem;

  img {
    width: 1.8rem;
  }
}

.sec-title {
  color: #fff;
  font-size: 0.35rem;
  line-height: 0.6rem;
  //margin-left: 0.25rem;
}

.game-box {
  position: fixed;
  width: 100vw;
  // max-width: @maxWidth;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 101;
  left: 0;
  right: 0;

  /deep/ iframe {
    width: 100vw;
  }
}

.back_to_desk {
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  height: 1rem;
  width: 1rem;
  // display: flex;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 0.02rem solid #fff;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem 0.2rem;
}

.close_game_btn {
  font-size: 0.8rem;
  border-radius: 50%;
  color: #fff;
}

.geme_page {
  :deep(.van-pagination__item) {
    width: 25px;
    height: 25px;
    margin: 0 2px;
    box-sizing: border-box;
    min-width: auto;
    flex: auto;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.5);
    border: 1px solid @bodercolor;
    font-size: 12px;
    overflow: hidden;
    color: @anttextcolor;
  }

  :deep(.van-pagination__item--active) {
    background-color: @textcolor1;
    color: @primary-color;
    border: none;

    &::after {
      border: none;
    }
  }
}
</style>